import { render, staticRenderFns } from "./ComponentText.vue?vue&type=template&id=6dc41bfb&scoped=true&"
import script from "./ComponentText.vue?vue&type=script&lang=js&"
export * from "./ComponentText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc41bfb",
  null
  
)

export default component.exports